import React from "react";
import { SvgIcon } from "@mui/material";

const PersonBenchMarkICon = (props) => {
  const propsToUse = { ...props };
  delete propsToUse.bodyFill;
  delete propsToUse.headFill;
  delete propsToUse.progress;
  return (
    <SvgIcon
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 34.8 107.02"
      {...propsToUse}
    >
      <pattern
        id="pattern1"
        x="0"
        y="0"
        width="34.8"
        height="107.02"
        patternUnits="userSpaceOnUse"
      >
        <rect
          style={{
            transform: `translateY(${props.progress}%)`,
            transition: "0.3s all",
          }}
          id="fillshape"
          x="0"
          y="0"
          width="100%"
          height="200%"
          stroke="none"
          fill="#CDDADD"
        />
      </pattern>
      <g fill="url(#pattern1)" id="Layer_2" data-name="Layer 2">
        <g fill="url(#pattern1)" id="Layer_1-2" data-name="Layer 1">
          <path
            fill={props.headFill}
            d="M6.22,11.19A11.19,11.19,0,1,1,17.4,22.37,11.18,11.18,0,0,1,6.22,11.19"
          />
          <path
            fill={props.bodyFill}
            d="M24.41,27.4h-14A10.23,10.23,0,0,0,0,37.48V60.42A10.13,10.13,0,0,0,7.27,70v27.6A9.31,9.31,0,0,0,16.58,107h1.64a9.32,9.32,0,0,0,9.32-9.32V70a10.14,10.14,0,0,0,7.26-9.62V37.48A10.24,10.24,0,0,0,24.41,27.4"
          />
          <path
            fill="url(#pattern1)"
            d="M6.22,11.19A11.19,11.19,0,1,1,17.4,22.37,11.18,11.18,0,0,1,6.22,11.19"
          />
          <path
            fill="url(#pattern1)"
            d="M24.41,27.4h-14A10.23,10.23,0,0,0,0,37.48V60.42A10.13,10.13,0,0,0,7.27,70v27.6A9.31,9.31,0,0,0,16.58,107h1.64a9.32,9.32,0,0,0,9.32-9.32V70a10.14,10.14,0,0,0,7.26-9.62V37.48A10.24,10.24,0,0,0,24.41,27.4"
          />
        </g>
      </g>
    </SvgIcon>
  );
};

export default PersonBenchMarkICon;
